<template>
  <div class="main-header__login__dropdown__content">
    <div class="main-header__login__dropdown__top">
      <h5 class="main-header__login__title">{{ "ui.login" | trans }}</h5>
      <span class="main-header__offcanvas__close" @click="onClose"></span>
    </div>
    <div class="main-header__login__dropdown__body">
      <b-alert variant="danger" :show="!!error">{{ error }}</b-alert>
      <b-form class="mt-3" @submit.prevent="onSubmit">
        <app-form-input
          :placeholder="$trans('ui.email')"
          v-model="form.username"
          type="email"
          autocomplete="username"
        />
        <app-form-input
          :placeholder="$trans('ui.password')"
          v-model="form.password"
          type="password"
          autocomplete="current-password"
        />
      </b-form>

      <div class="main-header__account__forgot-password">
        <b-link
          :href="$websitePath('/resetting/request-token?context=default')"
          class="text-dark"
          >{{ "security.login.forgot_password" | trans }}</b-link
        >
      </div>
    </div>

    <div class="main-header__login__bottom">
      <app-button
        variant="black"
        block
        type="submit"
        :disabled="loading"
        :loading="loading"
      >
        {{ "ui.login" | trans }}
      </app-button>

      <b-button
        variant="outline-black"
        block
        class="mt-2"
        :to="{ name: 'register' }"
        >{{ "security.registration.register" | trans }}</b-button
      >
    </div>
  </div>
</template>

<script>
import AppFormInput from "@/components/form/FormInput";
import AppButton from "@/components/ui/Button";

export default {
  name: "AppLogin",
  props: {
    lastUsername: {
      type: String,
      required: false,
      default: null,
    },
    error: {
      type: String,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: { AppButton, AppFormInput },
  methods: {
    async onSubmit() {
      await this.$emit("input", this.form);
    },
    onClose() {
      this.$emit("close");
    },
  },
  watch: {
    lastUsername: {
      handler(value) {
        this.form.username = value;
      },
      immediate: true,
    },
  },
  data() {
    return {
      form: {
        username: null,
        password: null,
      },
    };
  },
};
</script>
